import React from 'react';
import CampoComboAnio from '../../UI/campos/CampoComboAnio.js';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import CampoComboPais from '../../UI/campos/CampoComboPais.js';
import CampoEditableFecha from '../../UI/campos/CampoEditableFecha.js';
import CampoEditableFechaCampos from '../../UI/campos/CampoEditableFechaCampos.js';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import * as Categorias from '../../constantes/Categorias.js';
import styles from '../NuevoTorneo.module.css';

const CamposTorneo = (props) => {
  const torneo = props.torneo;
  const editar = props.editar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <table className={`${styles.tablaDatos}`}>
      <tbody>
        <tr>
          <td className={`${styles.titulo}`}>Año</td>
          <td className={`${styles.valor}`}>
            <CampoComboAnio
              estilo={`${styles.campoAnio}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.ANIO}
              valor={torneo.anio}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Temporada</td>
          <td className={`${styles.valor}`}>
            <CampoEditableTexto
              estilo={`${styles.campoTemporada}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.TEMPORADA}
              valor={torneo.temporada}
              largo={7}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Fecha de Inicio</td>
          <td className={`${styles.valor}`}>
            <CampoEditableFechaCampos
              editar={editar}
              nombre={Campos.NuevoTorneo.FECHA_INICIO}
              anio={torneo.anioInicio}
              mes={torneo.mesInicio}
              dia={torneo.diaInicio}
              anioFijo={torneo.anio}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Fecha de Fin</td>
          <td className={`${styles.valor}`}>
            <CampoEditableFecha
              editar={editar}
              nombre={Campos.NuevoTorneo.FECHA_FIN}
              valor={torneo.fechaFin}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Categoría</td>
          <td className={`${styles.valor}`}>
            <CampoComboParametro
              estilo={`${styles.comboCategoria}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.CATEGORIA}
              tipoParametro={TipoParametro.CATEGORIA}
              valor={torneo.categoria}
              codigoPorDefecto={Categorias.MAYOR}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Tipo Torneo</td>
          <td className={`${styles.valor}`}>
            <CampoComboParametro
              estilo={`${styles.comboTipoTorneo}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.TIPO_TORNEO}
              tipoParametro={TipoParametro.TIPO_TORNEO}
              valor={torneo.tipoTorneo}
              campoDescripcion="nombre"
              onChange={onCampoChange}
            />
          </td>
        </tr>

        {torneo.tipoTorneo?.oficialidad?.dePais && (
          <tr>
            <td className={`${styles.titulo}`}>País</td>
            <td className={`${styles.valor}`}>
              <CampoComboPais
                estilo={`${styles.comboPais}`}
                editar={editar}
                nombre={Campos.NuevoTorneo.PAIS}
                valor={torneo.pais}
                incluirNulo={false}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        )}

        <tr>
          <td className={`${styles.titulo}`}>Nombre</td>
          <td className={`${styles.valor}`}>
            <CampoEditableTexto
              estilo={`${styles.campoDescripcion}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.NOMBRE}
              valor={torneo.nombre}
              largo={50}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Cantidad Participantes</td>
          <td className={`${styles.valor}`}>
            <CampoEditableNumero
              estilo={`${styles.campoCantidad}`}
              editar={editar}
              nombre={Campos.NuevoTorneo.CANTIDAD_PARTICIPANTES}
              valor={torneo.cantidadParticipantes}
              largo={5}
              onChange={onCampoChange}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CamposTorneo;
